import { render } from "./SimplifiedLanding.vue?vue&type=template&id=6319ff4e&scoped=true"
import script from "./SimplifiedLanding.vue?vue&type=script&lang=js"
export * from "./SimplifiedLanding.vue?vue&type=script&lang=js"

import "./SimplifiedLanding.vue?vue&type=style&index=0&id=6319ff4e&scoped=true&lang=css"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/amane_dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6319ff4e"]])

export default __exports__